<template>
  <v-dialog v-model="modal" max-width="700">
    <v-card>
      <v-card-title> Renvoyer l'invitation</v-card-title>
      <v-card-text>
        <p>Vous allez renvoyer cette invitation à l'adresse {{ invitation?.email }}.</p>
        <p>Confirmez-vous ?</p>
      </v-card-text>
      <v-card-actions>
        <v-btn data-testid="valider-renvoyer-invitation" :loading="working" @click="valide" color="primary"> Renvoyer </v-btn>
        <v-btn data-testid="annuler-renvoyer-invitation" :disabled="working" @click="ferme">Annuler</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import makeVuexSnackbar from "@/mixins/makeVuexSnackbar";
import makeDialog from "@/mixins/makeDialog";
import { associationService } from "@/services";
export default {
  mixins: [makeVuexSnackbar(), makeDialog],
  data() {
    return {
      invitation: null,
      association: null,
      working: false,
    };
  },
  methods: {
    demarre(association, invitation) {
      this.invitation = invitation;
      this.association = association;
      this.ouvre();
    },

    valide() {
      this.working = true;
      associationService
        .reenvoiInvitation(this.association, this.invitation.tacheRattachement)
        .then(
          () => { this.snackbar( { text: "Le courriel d'invitation a été renvoyé.", color: "success" } ); this.ferme();},
          error => { this.snackbar( { text: "Le courriel d'invitation n'a pas été renvoyé.", color: "error" }, error ); this.ferme(); }
        )
        .finally(() => {
          this.working = false;
        });
    },
  },
};
</script>
